/**
 * English for the shell (card У1): the rail, the Top bar's crumbs, ⌘K and
 * the appearance controls. Spread into `en`, so the keys are part of `TKey`
 * and `ru.shell.ts` must cover every one of them.
 */
export const enShell = {
  "nav.library": "Library",
  "nav.offers": "Offers",
  "nav.landers": "Landers",
  "nav.partners": "Partner networks",
  "nav.sources": "Sources",
  "nav.collapse": "Collapse the rail",
  "nav.expand": "Expand the rail",
  "nav.shortcuts": "Navigation",
  "nav.crumbs": "Where you are",
  "crumb.edit": "Edit",

  "appearance.title": "Appearance",
  "appearance.trigger": "Appearance: {tier}",
  "appearance.theme": "Theme",
  "appearance.theme.description": "Until you pick one, the brand's theme is used. The choice is kept in this browser",
  "appearance.theme.dark": "Dark",
  "appearance.theme.light": "Light",
  "appearance.theme.black": "Black",
  "appearance.theme.system": "Like the system",
  "appearance.theme.dark.hint": "for long sessions",
  "appearance.theme.light.hint": "for bright light",
  "appearance.theme.black.hint": "OLED, no grey panels",
  "appearance.theme.system.hint": "now: {tier}",
  "appearance.systemHint": "«Like the system» follows your computer's light or dark setting.",
  "appearance.density": "Density",
  "appearance.density.description": "How many rows fit a table. On a MacBook 14 in compact — 22 campaigns without scrolling",
  "appearance.density.compact": "Compact",
  "appearance.density.default": "Regular",
  "appearance.density.comfortable": "Roomy",
  "appearance.density.compact.metrics": "Row 32 px · text 13 px",
  "appearance.density.default.metrics": "Row 36 px · text 14 px",
  "appearance.density.comfortable.metrics": "Row 44 px · text 14 px",

  "search.title": "Search the tracker",
  "search.empty": "Nothing found. Try another word.",
  "search.loading": "Searching…",
  "search.group.create": "Create",
  "search.group.places": "Sections",
  "search.group.campaigns": "Campaigns",
  "search.group.offers": "Offers",
  "search.group.landers": "Landers",
  "search.group.clicks": "Click",
  "search.group.account": "Account",
  "search.click": "Click {id}",
  "search.hint.choose": "choose",
  "search.hint.open": "open",
  "search.hint.close": "close",

  "notFound.title": "No such route",
  "notFound.body": "The link is out of date or the campaign was deleted.",
  "notFound.cta": "To campaigns",
};
